import { useTranslation } from "react-i18next";

import { Card, CardContent } from "@/components/ui/v2/card";

/** Shared sizing/colour for the icon every InfoItem renders in its leading circle. */
export const infoItemIconClass = "h-4 w-4 text-muted-foreground";

type InfoItemProps = {
  icon: React.ReactNode;
  label: string;
  value: string | null | undefined;
  /** When set (and a value is present), the value renders as a link opening this URL in a new tab. */
  href?: string | null;
};

export function InfoItem({ icon, label, value, href }: InfoItemProps) {
  const { t } = useTranslation();
  const hasValue = Boolean(value) 
  return (
    <Card padding="xs">
      <CardContent className="flex items-center gap-4 px-5 py-4">
        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-muted/60 border border-foreground/10">
          {icon}
        </div>
        <div className="min-w-0">
          <p className="text-xs text-muted-foreground mb-0.5">{label}</p>
          {hasValue && href ? (
            <a
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm font-semibold truncate block text-primary hover:underline"
            >
              {value}
            </a>
          ) : (
            <p className={hasValue ? "text-sm font-semibold truncate" : "text-sm text-muted-foreground/60 italic"}>
              {hasValue ? value : t("common.notAvailable")}
            </p>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
